export default __webpack_public_path__ + "static/media/intro_box_layer.9c9e77a5.svg";